/** @format */

const template = `
<div class="row" valdr-enabled="false">
  <div class="col-md-12 col-12" ng-class="{'disable-clear':!ctrl.allowClear}">
    <ng-form name="{{ctrl.name}}">
      <ui-select
        reset-search-input="true"
        ng-model="ctrl.value"
        on-select="ctrl.selectItem($item)"
        theme="bootstrap"
        append-to-body="false">
        <ui-select-match allow-clear="true" placeholder="{{ 'SIS_COMPONENTS.OBJECT.REFERRED_OBJECT_SELECT_EDITOR.SEARCH' | translate }}">
          {{ ctrl.getSelectedName($select.selected) }}
        </ui-select-match>
        <ui-select-choices
          position="down"
          class="ui-select-choices"
          group-by="ctrl.groupBy"
          group-filter="ctrl.groupFilter()"
          ui-disable-choice="ctrl.isDisabled(item)"
          refresh="ctrl.filterData($select.search)"
          refresh-delay="100"
          repeat="item in ctrl.filterResults | filter:$select.search">
          <span data-cy="ui-select-option" title="{{item.name | localizedString}}">
            <transpile [content]="item.name | localizedString | highlightResult:$select.search" />
          </span>
          <span ng-if="ctrl.showShortName && !item.skipShortName">(<span ng-bind="item.shortName | localizedString"></span>)</span>
          <span ng-if="item.deprecated" class="additional-info">{{ 'SIS_COMPONENTS.SELECT.DEPRECATED' | translate }}</span>
          <span ng-if="item.more" class="info-too-many-results">{{ item.more }}</span>
        </ui-select-choices>
      </ui-select>

      <ul class="error-list" ng-show="ctrl.form.$error[ctrl.name + '.required']">
        <li class="ng-hide" ng-show="ctrl.form.$error[ctrl.name + '.required']" translate
          >SIS_COMPONENTS.OBJECT.REFERRED_OBJECT_SELECT_EDITOR.REQUIRED</li
        >
      </ul>
    </ng-form>
  </div>
</div>
`;
export default template;
